"use strict";

import { lcvReportsConstants } from "../_constants/lcvReports.constants";

export const lcvReportsGetDealersRequest = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_DEALERS_REQUEST,
          payload,
     };
};

export const lcvReportsGetDealersComplete = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_DEALERS_COMPLETE,
          payload,
     };
};

export const lcvReportsGetDealersExportRequest = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_DEALERS_EXPORT_REQUEST,
          payload,
     };
};

export const lcvReportsGetDealersExportComplete = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_DEALERS_EXPORT_COMPLETE,
          payload,
     };
};

export const lcvReportsClearDealersExport = () => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_CLEAR_DEALERS_EXPORT,
     };
};

export const lcvReportsGetGamesRequest = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_GAMES_REQUEST,
          payload,
     };
};

export const lcvReportsGetGamesComplete = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_GAMES_COMPLETE,
          payload,
     };
};

export const lcvReportsGetGamesExportRequest = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_GAMES_EXPORT_REQUEST,
          payload,
     };
};

export const lcvReportsGetGamesExportComplete = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_GAMES_EXPORT_COMPLETE,
          payload,
     };
};

export const lcvReportsClearGamesExport = () => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_CLEAR_GAMES_EXPORT,
     };
};

export const lcvReportsGetFilterOptionsRequest = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_FILTER_OPTIONS_REQUEST,
          payload,
     };
};

export const lcvReportsGetFilterOptionsComplete = (payload) => {
     return {
          type: lcvReportsConstants.LCV_REPORTS_GET_FILTER_OPTIONS_COMPLETE,
          payload,
     };
};
